export var MarketplaceV1;
(function (MarketplaceV1) {
    /**
     * Enum for community product types.
     */
    let CommunityProductType;
    (function (CommunityProductType) {
        CommunityProductType["Subscription"] = "Subscription";
    })(CommunityProductType = MarketplaceV1.CommunityProductType || (MarketplaceV1.CommunityProductType = {}));
    /**
     * Enum for subscription frequencies.
     */
    let CommunitySubscriptionFrequency;
    (function (CommunitySubscriptionFrequency) {
        CommunitySubscriptionFrequency["OneTime"] = "OneTime";
        CommunitySubscriptionFrequency["Annual"] = "Annual";
    })(CommunitySubscriptionFrequency = MarketplaceV1.CommunitySubscriptionFrequency || (MarketplaceV1.CommunitySubscriptionFrequency = {}));
    let UserCommunityMembershipStatus;
    (function (UserCommunityMembershipStatus) {
        UserCommunityMembershipStatus["Active"] = "Active";
        UserCommunityMembershipStatus["Lapsed"] = "Lapsed";
        UserCommunityMembershipStatus["Cancelled"] = "Cancelled";
    })(UserCommunityMembershipStatus = MarketplaceV1.UserCommunityMembershipStatus || (MarketplaceV1.UserCommunityMembershipStatus = {}));
    let UserCommunityProductStatus;
    (function (UserCommunityProductStatus) {
        /**
         * When the user has paid for the product and is active.
         * The user has access to the product and its benefits.
         */
        UserCommunityProductStatus["Active"] = "Active";
        /**
         * When the user has paid for the product but the payment is pending.
         * The user HAS NOT received the product yet.
         */
        UserCommunityProductStatus["Pending"] = "Pending";
        /**
         * When the user has paid for the product but the subscription has lapsed.
         * The user has lost access to the product and its benefits.
         */
        UserCommunityProductStatus["Lapsed"] = "Lapsed";
        /**
         * When the user has cancelled the product.
         * The user has lost access to the product and its benefits.
         */
        UserCommunityProductStatus["Cancelled"] = "Cancelled";
    })(UserCommunityProductStatus = MarketplaceV1.UserCommunityProductStatus || (MarketplaceV1.UserCommunityProductStatus = {}));
})(MarketplaceV1 || (MarketplaceV1 = {}));
